// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "配电自动化",
      "tec": "孙震敖",
      "week": "1-8周",
      "add": "教学楼C座115教务"
    },
    0,
    {
      "sub": "电力系统自动化",
      "tec": "金红洋",
      "week": "2,4,6,8周",
      "add": "教学楼C座215教务"
    },
    0,
    0
  ],
  "2": [
    {
      "sub": "二次回路",
      "tec": "高鑫家",
      "week": "1-8周",
      "add": "教学楼C座310教务"
    },
    {
      "sub": "电网规划与设计",
      "tec": "谢洪放钟丹田",
      "week": "2,4,6,8周",
      "add": "教学楼C座113教务"
    },
    0,
    {
      "sub": "电气CAD",
      "tec": "冯丽",
      "week": "4-11周",
      "add": "实训楼C座103"
    },
    0
  ],
  "3": [
    0,
    {
      "sub": "电力系统自动化",
      "tec": "金红洋",
      "week": "1-8周",
      "add": "教学楼A座225电力"
    },
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "二次回路",
      "tec": "高鑫家",
      "week": "1-8周",
      "add": "教学楼A座118电力"
    },
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "电网规划与设计",
      "tec": "谢洪放钟丹田",
      "week": "1-8周",
      "add": "教学楼C座114教务"
    },
    0,
    {
      "sub": "电气CAD",
      "tec": "冯丽",
      "week": "4-11周",
      "add": "实训楼C座103"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
